import React, { useEffect, useState } from 'react';
import { Tabs } from './LessonResources';
import { GFLessonResource } from '../../models/models';
import LessonResourceSingleTabItem from './LessonResourceSingleTabItem';

type Props = {
  name: Tabs,
  currentTab: Tabs,
  currentItem: number,
  handleMultiSelect: (name: Tabs, index: number) => void,
  items: GFLessonResource[],
}

const LessonResourceMultiTabItem: React.FunctionComponent<Props> = ({
  name,
  currentTab,
  currentItem,
  handleMultiSelect,
  items,
  children,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    setIsOpen(currentTab === name);
  }, [currentTab, name]);

  const open = () => {
    handleMultiSelect(name, 0);
    setIsOpen(true);
  }

  if (items.length === 1 || ! isOpen) {
    return <LessonResourceSingleTabItem
      name={name}
      currentTab={currentTab}
      handleSelect={() => handleMultiSelect(name, 0)}
    >
      {children}
    </LessonResourceSingleTabItem>
  }

  return <div className="multi">
    {children}
    {items.map((item, index) => {
      return <div
        key={item.url}
        className={currentTab === name && currentItem === index ? 'selected multi-item': 'multi-item'}
        onClick={() => handleMultiSelect(name, index)}
      >
        {item.label}
      </div>
    })}
  </div>;
};

export default LessonResourceMultiTabItem;
